import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';
import { nextIntlConfig } from './constants';

export const routing = defineRouting(nextIntlConfig);

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname, permanentRedirect }
  = createNavigation(routing);
